export enum EEditorContentAction {
  SplitTextCreateNode = 'splitTextCreateNode',
  SplitTextCreateNodeFailed = 'splitTextCreateNodeFailed',
  CreateNode = 'createNode',
  CreateNodeFailed = 'createNodeFailed',
  UpdateNode = 'updateNode',
  UpdateNodeFailed = 'updateNodeFailed',
  MoveNodes = 'moveNodes',
  MoveNodesFailed = 'moveNodesFailed',
  DeleteNode = 'deleteNode',
  DeleteNodeFailed = 'deleteNodeFailed',
}

export enum EEditorContentMutation {
  ReplaceBlock = 'replaceBlock',
  CreateNode = 'createNode',
  UpdateNode = 'updateNode',
  MoveNodes = 'moveNodes',
  DeleteNode = 'deleteNode',
}

export enum EEditorContentGetter {
  AllEditorFields = 'allEditorFields',
}
